import { has, isArray, omit } from 'lodash'

export const makeOneLevelArray = (
  itemList = [],
  childrenField = 'children'
) => {
  let result: any[] = []

  itemList.forEach((item) => {
    result.push(omit(item, [childrenField]))

    if (has(item, childrenField) && isArray(item[childrenField])) {
      result = result.concat(
        makeOneLevelArray(item[childrenField], childrenField)
      )
    }
  })

  return result
}
